var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconcheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "#f3123c",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.3,4.1,10.892,18.509a2.4,2.4,0,0,1-3.4,0L.7,11.715a2.4,2.4,0,0,1,3.4-3.4l5.094,5.1L21.905.7a2.4,2.4,0,1,1,3.4,3.4Z",
    transform: "translate(11.002 14.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,48A24,24,0,0,1,7.019,7.021a24.014,24.014,0,0,1,33.963,33.96A23.865,23.865,0,0,1,24,48ZM24,4.8A19.208,19.208,0,0,0,10.416,37.584,19.208,19.208,0,0,0,37.582,10.42,19.074,19.074,0,0,0,24,4.8Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconcheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconcheck.6c7864d0.svg";
export { ForwardRef as ReactComponent };